import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './index.css';

const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);

function Home() {
  return (
    <div className="video-page">
      <video
        className="bg-video"
        src={isMobile ? '/nova-rockets-mobile.mp4' : '/nova-rockets.mp4'}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}
